import { gql } from '@apollo/client';

export const PageFragments = gql`
  fragment PageFragments on Page {
    id
    title
    slug
    seo {
      fullHead
    }
    locale {
      id
      locale
    }
    blocks {
      attributes {
        name
        value
      }
      id
      innerHtml
      tagName
      type
    }
    homepageFirstBlock {
      accentColor
      title
      description
      image1 {
        id
        altText
        mediaItemUrl
      }
      image2 {
        id
        altText
        mediaItemUrl
      }
      image3 {
        id
        altText
        mediaItemUrl
      }
      image4 {
        id
        altText
        mediaItemUrl
      }
    }
  }
`;

export const GET_PAGE = gql`
  query Page($asPreview: Boolean, $id: ID!, $idType: PageIdType) {
    page(asPreview: $asPreview, id: $id, idType: $idType) {
      ...PageFragments
      translated {
        ...PageFragments
      }
    }
  }
  ${PageFragments}
`;
